import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import * as $ from 'jquery';
import { CryptService } from 'services/crypt/crypt.service';
import { AuthService } from 'services/auth/auth.service';

@Component({
	selector: 'app-my-app',
	templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
	private _router: Subscription;
	session: any = false;

	constructor(
		private router: Router,
		public crypt: CryptService,
		private authService: AuthService,
	) {
		$(document).keydown(function (e) {
			return (e.which || e.keyCode) != 116;
		});
		window.oncontextmenu = function () {
			return false;
		}

		$('input').val(function () {
			return this.value.toUpperCase();
		})
	}

	async ngOnInit() {

		$(() => {

			setTimeout(() => {
				$(".mc-autocomplete").append("<i class='material-icons mc-autocomplete-arrow'>arrow_drop_down</i>");
			}, 2000);


		});

		this.session = localStorage.getItem('session');

		if (!this.session) {

			this.router.navigate(['pages/login']);

		} else if (this.session == 0) {

			this.router.navigate(['pages/login']);

		} else if (this.session == 1) {

			try {
				const eA23 = localStorage.getItem("eA23")
				let decrypted = await this.crypt.decrypt(eA23);
				// console.log(decrypted);
				// valido si no existe la variable de norenovacion para evitar que al
				// borrarla del localStorage puedan realizar la renovacion sin permiso
				if (localStorage.getItem("eA24")) {

					if (localStorage.getItem("vote") == "1" && decrypted == "Alumno") {
						this.router.navigate(['elections/vote'])
					} else if (localStorage.getItem("vote") == "0" && decrypted == "Alumno") {
						this.router.navigate(['student/create_student'])
					} else if (decrypted == "Administrador") {
						this.router.navigate(['notes/logros']);
					} else {
						this.router.navigate(['page-not-found']);
					}

				} else {
					this.router.navigate(['page-not-found']);
				}
			} catch (error) {
				this.router.navigate(['page-not-found']);
			}
		} else {
			this.router.navigate(['pages/login']);
		}

		this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
			const body = document.getElementsByTagName('body')[0];
			const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
			if (body.classList.contains('modal-open')) {
				body.classList.remove('modal-open');
				modalBackdrop.remove();
			}
		});

		localStorage.setItem("mensaje", "1");

		let res = await this.authService.consultarEstado();
		console.log(res.acceso.mesBoletin);

		if (res.acceso.mesBoletin === "ABIERTO") {
			localStorage.setItem("mensaje", "1");
		} else {
			localStorage.setItem("mensaje", "2");
			this.router.navigate(['page-not-found']);
		}
	}

}

